import React from "react";
import {
    CARD_CONTAINER_WITH_BACKGROUND_CLASS,
    CARD_INNER_CONTAINER_CLASS,
    INNER_CARD_CONTAINER_WITH_BACKGROUND_CLASS,
    VIEW_PROFILE_TEXT,
} from "./constants";
import TypographyMontserrat from "../../Atoms/TypographyMontserrat";
import NewTertiaryButton from "../../Atoms/Buttons/NewTertiaryButton";
import { TertiaryRightArrow } from "../../../public/Theme";
import { sendGTMEvent } from "@next/third-parties/google";
import { GoogleTagManagerEvents } from "../../../common";

const NewStylistCard = ({
    description,
    image,
    index,
    instagram,
    name,
    link,
}) => {
    return (
        <div
            key={index}
            className={CARD_CONTAINER_WITH_BACKGROUND_CLASS}
            style={{
                backgroundImage: `url(${image?.url})`,
            }}
            loading="lazy"
        >
            <div className={INNER_CARD_CONTAINER_WITH_BACKGROUND_CLASS}>
                <div className={CARD_INNER_CONTAINER_CLASS}>
                    <TypographyMontserrat
                        align={"left"}
                        fontWeight={"semibold"}
                        color={"White"}
                        size={"28px"}
                        text={name}
                        customStyle={"!uppercase"}
                    />
                    <TypographyMontserrat
                        align={"left"}
                        color={"White"}
                        size={"base"}
                        text={description}
                        customStyle={"lg:mt-2"}
                    />

                    <NewTertiaryButton
                        text={VIEW_PROFILE_TEXT}
                        image={TertiaryRightArrow}
                        href={link}
                        onClick={() => {
                            sendGTMEvent({
                                event: GoogleTagManagerEvents.navigationInteractions,
                                place: "Stylist Section",
                                menu_name: "stylist-section",
                            });
                        }}
                    />
                </div>
            </div>
        </div>
    );
};

export default NewStylistCard;
